'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Space = require('../../Space/src/Space.js');
var Alert_module = require('../styles/Alert.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Alert component is used to show feedback to the user about an action or state
 *
 * @component
 * @example
 * ```jsx
 * <Alert icon={icon} title="Информационный заголовок" message="Информационное сообщение" />
 * ```
 */
const Alert = React__namespace.forwardRef((props, ref) => {
    const { title, subtitle, icon, variant, color, footer, closable, onClose, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Alert_module.default);
    const classNames = cx(className, 'container', {
        [`color-${color}-${variant}`]: true,
    });
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Alert", className: classNames, ...restProps },
        (!!icon || !!title || !!subtitle || !!closable) && (React__namespace.createElement(Space.Space, { size: 12, align: "center", className: cx('header') },
            icon && React__namespace.createElement("div", { className: cx('icon') }, icon),
            React__namespace.createElement(Space.Space, { direction: "vertical", size: 0, className: cx('title-wrapper') },
                title && React__namespace.createElement("div", { className: cx('title') }, title),
                subtitle && React__namespace.createElement("div", { className: cx('subtitle') }, subtitle)),
            closable && React__namespace.createElement(Icon.Icon, { className: cx('close'), icon: React__namespace.createElement(reactIcons.Cross, null), onClick: onClose }))),
        children && React__namespace.createElement("div", { className: cx('content') }, children),
        footer && (React__namespace.createElement(Space.Space, { size: 12, justify: "stretch", className: cx('footer') }, footer))));
});
Alert.defaultProps = {
    variant: 'secondary',
    color: 'dark',
};
Alert.displayName = 'Alert';

exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map
